import { isProductComplaintDisabled, isProductExchangeDisabled, isReturnDisabled } from "~/cores/productCore";
import React from "react";
import { RETURN_METHOD_COMPLAINT, RETURN_METHOD_EXCHANGE, RETURN_METHOD_RETURN } from "~/constants";
import OneClickOptionsWrapper, { OneClickTextAndIconOption } from "./OneClickOptions";
import { TurnrModalContainer, TurnrModalContent, TurnrModalHeader } from "~/components/modals/TurnrModal";
import ReturnIcon from "rylak-common/src/icons/ReturnIcon.jsx";
import ExchangeIcon from "rylak-common/src/icons/ExchangeIcon.jsx";
import ComplaintIcon from "rylak-common/src/icons/ComplaintIcon.jsx";
import { getAllAvailableVariantColors, getAllAvailableVariantSizes, getGiftCardPercentage, isGiftCardEnabled } from "~/cores/appCore";

export function getReturnMethodOptions(props) {
    const { appProps, product } = props;

    let returnList = [];
    if (!isProductExchangeDisabled(product, { appProps })) {
        returnList.push({
            value: RETURN_METHOD_EXCHANGE,
            Icon: ExchangeIcon,
        });
    }

    if (!isReturnDisabled(product, { appProps }))
        returnList = returnList.concat([
            {
                value: RETURN_METHOD_RETURN,
                Icon: ReturnIcon,
            },
        ]);
    if (!isProductComplaintDisabled(product, { appProps })) {
        returnList.push({
            value: RETURN_METHOD_COMPLAINT,
            Icon: ComplaintIcon,
        });
    }
    return returnList;
}

export default function MethodSelector(props) {
    const { setReturnMethod, onModalClose, appProps, productExchangeServiceData } = props;
    const { getLocaleText } = appProps;

    const returnMethodOptions = getReturnMethodOptions(props);
    const giftCardEnabled = isGiftCardEnabled(appProps);
    const giftCardPercentage = getGiftCardPercentage(appProps);

    function getSubtitle({ returnMethod }) {
        if (returnMethod === RETURN_METHOD_COMPLAINT) {
            return getLocaleText(["method-button-subtitle", returnMethod]);
        }

        if (returnMethod === RETURN_METHOD_RETURN) {
            if (giftCardEnabled) {
                return getLocaleText(["method-button-subtitle", returnMethod, "orByGiftCard"], {
                    giftCardPercentage: giftCardPercentage ? `+${giftCardPercentage * 100}%` : "",
                });
            } else {
                return getLocaleText(["method-button-subtitle", returnMethod, "paymentMethod"]);
            }
        }

        if (returnMethod === RETURN_METHOD_EXCHANGE) {
            const sizes = getAllAvailableVariantSizes({ productExchangeServiceData });
            const colors = getAllAvailableVariantColors({ productExchangeServiceData });
            if (sizes.length >= 2) {
                return (
                    <div>
                        {getLocaleText(["method-button-subtitle", returnMethod, "sizes"])} {sizes?.slice(0, 10).join(", ")?.slice(0, 45)} ...
                    </div>
                );
            }
            if (colors.length >= 2) {
                return (
                    <div>
                        {getLocaleText(["method-button-subtitle", returnMethod, "colors"])} {colors?.slice(0, 5).join(", ")} ...
                    </div>
                );
            }

            return getLocaleText(["method-button-subtitle", returnMethod, "rest"]);
        }
    }

    return (
        <TurnrModalContainer>
            <TurnrModalHeader onClose={onModalClose} title={getLocaleText("method-selector-title")} />
            <TurnrModalContent>
                <OneClickOptionsWrapper>
                    {returnMethodOptions.map((option) => {
                        const Icon = option.Icon;

                        return (
                            <OneClickTextAndIconOption
                                key={option.value}
                                title={getLocaleText(["method-button-title", option.value])}
                                description={getSubtitle({ returnMethod: option?.value })}
                                onClick={() => setReturnMethod(option.value)}
                                dataTestId={`method-select-${option.value}`}
                                Icon={Icon}
                            />
                        );
                    })}
                </OneClickOptionsWrapper>
            </TurnrModalContent>
        </TurnrModalContainer>
    );
}
